var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "text-center q-mb-md" },
      [
        _c("q-btn", {
          attrs: {
            to: { name: "app.settings.timeline" },
            label: "Go to timeline",
            "no-caps": ""
          }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("q-search", {
          attrs: {
            inverted: "",
            color: "secondary",
            "stack-label": "Search",
            placeholder: "default activation fee..."
          },
          on: { input: _vm.fetchSettings },
          model: {
            value: _vm.searchQuery,
            callback: function($$v) {
              _vm.searchQuery = $$v
            },
            expression: "searchQuery"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row gutter-md" },
      [
        _vm.settings.length
          ? _c("SettingCategories", {
              attrs: { settings: _vm.settings },
              on: { filter: _vm.filterByCategory }
            })
          : _vm._e(),
        _c(
          "q-list",
          {
            staticClass: "col-md-10",
            attrs: { "no-border": "", separator: "", sparse: "" }
          },
          _vm._l(_vm.filteredSettings, function(setting) {
            return _c(
              "q-item",
              { key: setting.id },
              [
                _c(
                  "q-item-main",
                  [
                    _c("SettingRow", {
                      attrs: {
                        setting: setting,
                        editable: _vm.hasEditPermission,
                        "with-children": ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          })
        ),
        _c("bj-inner-loading", { attrs: { visible: _vm.loading } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }